var map = {
	"./image-1.jpg": 7163,
	"./image-10.jpg": 7235,
	"./image-2.jpg": 716,
	"./image-3.jpg": 6089,
	"./image-4.jpg": 602,
	"./image-5.jpg": 5063,
	"./image-6.jpg": 840,
	"./image-7.jpg": 6853,
	"./image-8.jpg": 5814,
	"./image-9.jpg": 8979
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1817;